import { LogOut, Menu as MenuIcon } from 'lucide-react'
import {
  Button, Menu, MenuContent, MenuItem, MenuLabel, MenuSeparator, MenuTrigger,
} from '@bb/ui'
import { de } from '../i18n'
import { ThemeMenu } from './ThemeMenu'

export interface TopBarProps {
  userName: string
  userEmail: string
  onLogout: () => void
  onOpenMenu: () => void
  menuOpen: boolean
}

export function TopBar({ userName, userEmail, onLogout, onOpenMenu, menuOpen }: TopBarProps) {
  return (
    <header className="flex h-(--topbar-height) shrink-0 items-center justify-between gap-4 border-b border-rule bg-surface px-4">
      <div className="flex min-w-0 items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          aria-label={de.nav.openMenu}
          aria-expanded={menuOpen}
          onClick={onOpenMenu}
        >
          <MenuIcon className="size-4" />
        </Button>
      </div>

      <div className="flex items-center gap-1">
        <ThemeMenu />

        <Menu>
          <MenuTrigger asChild>
            <Button variant="ghost" size="sm" className="gap-2">
              <span
                aria-hidden
                className="flex size-5 items-center justify-center rounded-full bg-accent-soft text-2xs font-semibold text-accent"
              >
                {initials(userName)}
              </span>
              <span className="max-w-40 truncate">{userName}</span>
            </Button>
          </MenuTrigger>
          <MenuContent>
            <MenuLabel>{userEmail}</MenuLabel>
            <MenuSeparator />
            <MenuItem onSelect={onLogout}>
              <LogOut className="size-3.5" />
              {de.auth.logout}
            </MenuItem>
          </MenuContent>
        </Menu>
      </div>
    </header>
  )
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}
